import { supabase } from '@/lib/supabase'

export type InOutEventKey =
  | 'entry'
  | 'stop'
  | 'tp1'
  | 'tp2'
  | 'tp3'
  | 'entry_missed'

export type InOutTemplates = {
  entryTitle: string
  entryBody: string
  stopTitle: string
  stopBody: string
  tp1Title: string
  tp1Body: string
  tp2Title: string
  tp2Body: string
  tp3Title: string
  tp3Body: string
  entryMissedTitle: string
  entryMissedBody: string
}

const K_ENTRY_TITLE = 'ops.inout_entry_title'
const K_ENTRY_BODY = 'ops.inout_entry_body'
const K_STOP_TITLE = 'ops.inout_stop_title'
const K_STOP_BODY = 'ops.inout_stop_body'
const K_TP1_TITLE = 'ops.inout_tp1_title'
const K_TP1_BODY = 'ops.inout_tp1_body'
const K_TP2_TITLE = 'ops.inout_tp2_title'
const K_TP2_BODY = 'ops.inout_tp2_body'
const K_TP3_TITLE = 'ops.inout_tp3_title'
const K_TP3_BODY = 'ops.inout_tp3_body'
const K_ENTRY_MISSED_TITLE = 'ops.inout_entry_missed_title'
const K_ENTRY_MISSED_BODY = 'ops.inout_entry_missed_body'

const DEFAULTS: InOutTemplates = {
  entryMissedTitle:
    'Ativo Retomou a tendencia sem atingir pontos minimos de entrada.',
  entryMissedBody:
    '{ativo} atingiu TP3 sem tocar o entry_min. O sinal foi valido, mas nao houve ponto minimo de entrada para execucao.',
  entryTitle: '{ativo} entrou no range de entrada 💡',
  entryBody:
    'O preço de {ativo} entrou no range planejado. Momento ideal para revisar o setup e validar sua execução.',
  stopTitle: 'Stop de {ativo} atingido 🛡️',
  stopBody:
    'O stop de {ativo} foi atingido. Não é o cenário ideal, mas faz parte do jogo. Acompanhe novas oportunidades.',
  tp1Title: '{ativo} atingiu o Alvo 1 💰',
  tp1Body:
    'Primeiro alvo alcançado. Movimento alinhado. Avalie parcial e ajuste de stop.',
  tp2Title: '{ativo} atingiu o Alvo 2 💰💰',
  tp2Body:
    'Segundo alvo alcançado. Ótima continuidade. Avalie parcial e ajuste de stop.',
  tp3Title: '{ativo} atingiu o Alvo 3 💰💰💰',
  tp3Body:
    'Terceiro alvo alcançado. Excelente resultado 🔥 Avalie encerrar a posição. Acompanhe novas oportunidades do Cripto Alert.',
}

export async function getInOutTemplates(): Promise<InOutTemplates> {
  const keys = [
    K_ENTRY_TITLE,
    K_ENTRY_BODY,
    K_STOP_TITLE,
    K_STOP_BODY,
    K_TP1_TITLE,
    K_TP1_BODY,
    K_TP2_TITLE,
    K_TP2_BODY,
    K_TP3_TITLE,
    K_TP3_BODY,
    K_ENTRY_MISSED_TITLE,
    K_ENTRY_MISSED_BODY,
  ]
  const { data, error } = await supabase
    .from('app_settings')
    .select('key,value')
    .in('key', keys)

  if (error) return DEFAULTS
  const map = new Map<string, string>((data || []).map((r: any) => [String(r.key), String(r.value)]))

  return {
    entryTitle: map.get(K_ENTRY_TITLE) || DEFAULTS.entryTitle,
    entryBody: map.get(K_ENTRY_BODY) || DEFAULTS.entryBody,
    stopTitle: map.get(K_STOP_TITLE) || DEFAULTS.stopTitle,
    stopBody: map.get(K_STOP_BODY) || DEFAULTS.stopBody,
    tp1Title: map.get(K_TP1_TITLE) || DEFAULTS.tp1Title,
    tp1Body: map.get(K_TP1_BODY) || DEFAULTS.tp1Body,
    tp2Title: map.get(K_TP2_TITLE) || DEFAULTS.tp2Title,
    tp2Body: map.get(K_TP2_BODY) || DEFAULTS.tp2Body,
    tp3Title: map.get(K_TP3_TITLE) || DEFAULTS.tp3Title,
    tp3Body: map.get(K_TP3_BODY) || DEFAULTS.tp3Body,
    entryMissedTitle: map.get(K_ENTRY_MISSED_TITLE) || DEFAULTS.entryMissedTitle,
    entryMissedBody: map.get(K_ENTRY_MISSED_BODY) || DEFAULTS.entryMissedBody,
  }
}

export async function setInOutTemplates(t: InOutTemplates): Promise<void> {
  const rows = [
    { key: K_ENTRY_TITLE, value: String(t.entryTitle || DEFAULTS.entryTitle) },
    { key: K_ENTRY_BODY, value: String(t.entryBody || DEFAULTS.entryBody) },
    { key: K_STOP_TITLE, value: String(t.stopTitle || DEFAULTS.stopTitle) },
    { key: K_STOP_BODY, value: String(t.stopBody || DEFAULTS.stopBody) },
    { key: K_TP1_TITLE, value: String(t.tp1Title || DEFAULTS.tp1Title) },
    { key: K_TP1_BODY, value: String(t.tp1Body || DEFAULTS.tp1Body) },
    { key: K_TP2_TITLE, value: String(t.tp2Title || DEFAULTS.tp2Title) },
    { key: K_TP2_BODY, value: String(t.tp2Body || DEFAULTS.tp2Body) },
    { key: K_TP3_TITLE, value: String(t.tp3Title || DEFAULTS.tp3Title) },
    { key: K_TP3_BODY, value: String(t.tp3Body || DEFAULTS.tp3Body) },
    {
      key: K_ENTRY_MISSED_TITLE,
      value: String(t.entryMissedTitle || DEFAULTS.entryMissedTitle),
    },
    {
      key: K_ENTRY_MISSED_BODY,
      value: String(t.entryMissedBody || DEFAULTS.entryMissedBody),
    },
  ]

  const { error } = await supabase.from('app_settings').upsert(rows as any, { onConflict: 'key' })
  if (error) throw error
}
